import { EmbeddedCheckout, EmbeddedCheckoutProvider } from '@stripe/react-stripe-js';
import { loadStripe, Stripe } from '@stripe/stripe-js';
import { useMemo } from 'react';

/**
 * Stripe Embedded Checkout mounted inside our page (iframe), the Stripe analog of
 * Dintero's embedded widget. Initialized with a `clientSecret` from a Checkout
 * Session created server-side with `ui_mode: 'embedded_page'`. For Stripe Connect the
 * connected account is scoped via `stripeAccount` at load time. On completion
 * Stripe redirects the top window to the session's `return_url`.
 */
export function StripeEmbeddedPaymentForm({
  clientSecret,
  publishableKey,
  stripeAccountId
}: {
  clientSecret: string;
  publishableKey: string;
  stripeAccountId: string | null;
}) {
  const stripePromise = useMemo<Promise<Stripe | null>>(
    () => loadStripe(publishableKey, stripeAccountId ? { stripeAccount: stripeAccountId } : undefined),
    [publishableKey, stripeAccountId]
  );

  return (
    <div className='mt-5 min-h-200'>
      <EmbeddedCheckoutProvider stripe={stripePromise} options={{ clientSecret }}>
        <EmbeddedCheckout />
      </EmbeddedCheckoutProvider>
    </div>
  );
}
